import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { motion } from "framer-motion"
import Header from "./header"
import Footer from "./footer"
import "./locomotive-scroll.css"
import Seo from "./seo"

const Layout = ({ children, path, location, pageSeo, className }) => {
  const data = useStaticQuery(graphql`
    query SiteLayoutQuery {
      general: sanitySettingsGeneral {
        siteTitle
        siteURL
        id
        home {
          slug {
            current
          }
        }
      }
      header: sanitySettingsHeader {
        id
        logo {
          asset {
            altText
            gatsbyImageData
          }
        }
        logo_secondary {
          _key
          _type
          asset {
            altText
            gatsbyImageData
          }
        }
        menuDesktopPrimary {
          id
          title
          slug {
            current
          }
          link {
            ... on SanityLinkInternal {
              _key
              _type
              title
              page {
                ... on SanityPage {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityCareers {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityBlog {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityWork {
                  id
                  slug {
                    current
                  }
                }
              }
            }
            ... on SanityLinkExternal {
              _key
              _type
              url
              title
            }
          }
        }
      }
      footer: sanitySettingsFooter {
        id
        siteInfoTitle
        siteInfoTagline
        primaryMenuTitle
        primaryMenu {
          id
          title
          slug {
            current
          }
          link {
            ... on SanityLinkInternal {
              _key
              _type
              title
              page {
                ... on SanityPage {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityCareers {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityBlog {
                  id
                  slug {
                    current
                  }
                }
                ... on SanityWork {
                  id
                  slug {
                    current
                  }
                }
              }
            }
            ... on SanityLinkExternal {
              _key
              _type
              url
              title
            }
          }
        }
      }
      cookie: sanitySettingsCookie {
        id
        message
        enabled
        link {
          id
          title
          slug {
            current
          }
        }
      }
      promo: sanitySettingsPromo {
        id
        text
        link {
          id
          title
          slug {
            current
          }
        }
      }
      seo: sanitySettingsSeo {
        id
        metaTitle
        metaDesc
        shareGraphic {
          asset {
            url
          }
        }
      }
      socials: sanitySettingsSocials {
        socialMenuTitle
        social {
          _key
          _type
          icon
          url
        }
      }
    }
  `)

  const { general, header, footer, cookie, promo, seo, page, socials } = data

  console.log("layout query", data)

  // console.log("pageSeo", pageSeo)
  return (
    <>
    {/* <Seo /> */}
      {/* <Helmet>
        <meta charSet="utf-8" />
        <title>{seo.metaTitle} - </title>
        <link rel="canonical" href="http://mysite.com/example" />
        <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=ac7310ea-b6ef-43cf-8218-f2bc0dfa4d9b"> </script>

      </Helmet> */}
      <Seo seo={seo} pageSeo={pageSeo}/>
      <Header header={header} site={general} />

      {/* Here we pass the callbacks to the component. Anything that impacts the innerHeight, for example: Font Loaded */}
      {/* <Scroll callbacks={location} /> */}

      {/* <main>{children}</main> */}

      <motion.main
        key={path}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        // initial={{ y: "10px", opacity: 0 }}
        // animate={{ y: 0, opacity: 1 }}
        exit={{ opacity: 0, y: "-10px" }}
        transition={{
          duration: 0.6,
          mass: 0.35,
          stiffness: 75,
        }}
        // transition={{
        //   type: "spring",
        //   mass: 0.35,
        //   stiffness: 75,
        //   duration: 2,
        // }}
      >
        {children}
      </motion.main>

      <Footer
        logo={header.logo}
        logoSecondary={header.logo_secondary}
        footer={footer}
        socials={socials}
        general={general}
      />


    </>
  )
}

export default Layout


